import { Box, Tab, Tabs, Tooltip } from "@mui/material";
import { FC, useEffect, useState } from "react";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Colors } from "../../theme";
import { useLocation, useNavigate } from "react-router-dom";

const navigations = ["home", "tradematcher"];

export const NavBar: FC = () => {
  const location = useLocation();
  const locationWithoutSlash = location.pathname.split("/")[1];
  const [value, setValue] = useState(
    locationWithoutSlash.length ? locationWithoutSlash : "home",
  );
  const navigate = useNavigate();

  useEffect(() => {
    setValue(
      locationWithoutSlash === "" ? "home" : (locationWithoutSlash ?? "home"),
    );
  }, [locationWithoutSlash]);

  const onValChange = (
    _e: React.SyntheticEvent<Element, Event>,
    value: string,
  ) => {
    setValue(value);
    navigate(`/${value}`);
  };

  return (
    <Box
      sx={{
        gap: 2,
        backgroundColor: (t) =>
          t.palette.mode === "dark" ? "#161b22" : t.palette.primary.dark,
        width: 48,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 9,
        boxShadow: (t) =>
          t.palette.mode === "dark"
            ? "none"
            : "2px 0px 8px rgba(0, 0, 0, 0.3), inset -1px 0px 0px rgba(0, 0, 0, 0.1)",
        borderRight: (t) =>
          t.palette.mode === "dark"
            ? "1px solid rgba(255, 255, 255, 0.06)"
            : "none",
        "& .Mui-selected svg": {
          fill: Colors.MFT_ORANGE,
        },
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={onValChange}
        indicatorColor="secondary"
        sx={{
          maxWidth: 48,
          minWidth: 48,
        }}
      >
        {navigations.map((nav) => {
          return (
            <Tab
              key={nav}
              value={nav}
              label={
                <Tooltip title={getTitle(nav)} placement="right" arrow>
                  {getIcon(nav)}
                </Tooltip>
              }
              sx={{
                marginTop: 0,
                marginBottom: 0,
                width: 40,
                maxWidth: 48,
                minWidth: 48,
                minHeight: 56,
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

const getIcon = (nav: string) => {
  switch (nav) {
    case "home":
      return <HomeOutlinedIcon sx={{ color: (t) => t.palette.MFT_CREAM }} />;
    case "tradematcher":
      return (
        <CompareArrowsOutlinedIcon sx={{ color: (t) => t.palette.MFT_CREAM }} />
      );
    default:
      return <></>;
  }
};

const getTitle = (nav: string) => {
  switch (nav) {
    case "home":
      return "Home";
    case "tradematcher":
      return "Trade Matcher";
    default:
      return "";
  }
};
